import builder from './reducerBuilder'
import {
  ACTION_ENTERPRISE_ACCOUNT_CREATE_LOADING,
  ACTION_ENTERPRISE_ACCOUNT_CREATE_LOADED,
  ACTION_ENTERPRISE_ACCOUNT_CREATE_ERROR,
  ACTION_ENTERPRISE_ACCOUNT_SHOW_LOADING,
  ACTION_ENTERPRISE_ACCOUNT_SHOW_LOADED,
  ACTION_ENTERPRISE_ACCOUNT_SHOW_ERROR,
  ACTION_ENTERPRISE_ACCOUNT_UPDATE_LOADING,
  ACTION_ENTERPRISE_ACCOUNT_UPDATE_LOADED,
  ACTION_ENTERPRISE_ACCOUNT_UPDATE_ERROR,
} from '../constants'

export default builder(
  [ACTION_ENTERPRISE_ACCOUNT_CREATE_LOADING, ACTION_ENTERPRISE_ACCOUNT_SHOW_LOADING, ACTION_ENTERPRISE_ACCOUNT_UPDATE_LOADING],
  [ACTION_ENTERPRISE_ACCOUNT_CREATE_LOADED, ACTION_ENTERPRISE_ACCOUNT_SHOW_LOADED, ACTION_ENTERPRISE_ACCOUNT_UPDATE_LOADED],
  [ACTION_ENTERPRISE_ACCOUNT_CREATE_ERROR, ACTION_ENTERPRISE_ACCOUNT_SHOW_ERROR, ACTION_ENTERPRISE_ACCOUNT_UPDATE_ERROR])



// WEBPACK FOOTER //
// ./src/store/enterpriseAccountReducer.js